module.exports = __webpack_public_path__ + "officialStatic/img/roleBg.4ae34d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/roleBg.jpg
// module id = kFzX
// module chunks = 0